import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ICreatePersonalSalud,
  IPersonalSalud,
  IUpdatePersonalSalud,
} from 'modelos/src';
import { AuxiliaresModule } from '../../../../../../auxiliares/auxiliares.module';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { PersonalesSaludService } from '../../../../../../auxiliares/servicios/http/personales-salud.service';
import { LoginService } from '../../../../../login/login.service';
import { iconoRolSalud } from '../../presentacion-entidades';

@Component({
  selector: 'app-crear-editar-personal-salud',
  imports: [AuxiliaresModule],
  templateUrl: './crear-editar-personal-salud.component.html',
  styleUrl: '../../../form-dialogo.scss',
})
export class CrearEditarPersonalSaludComponent implements OnInit {
  helper = inject(HelperService);
  private service = inject(PersonalesSaludService);
  // Siempre en diálogo: { id } edita; sin datos, crea.
  data = inject<{ id?: string } | null>(MAT_DIALOG_DATA, { optional: true });
  dialogRef =
    inject<MatDialogRef<CrearEditarPersonalSaludComponent>>(MatDialogRef);

  public id?: string | null;
  public loading = true;
  public guardando = false;
  public form?: FormGroup;
  public title = '';
  public subtitle?: string;
  public personal?: IPersonalSalud;
  public roles: NonNullable<IPersonalSalud['rol']>[] = ['Médico', 'Enfermero'];
  public mostrarCliente = HelperService.getTipoCliente() !== 'Final';
  public iconoRol = iconoRolSalud;

  private createForm(): void {
    const p = this.personal;
    this.form = new FormGroup({
      nombre: new FormControl(p?.nombre, Validators.required),
      rol: new FormControl(p?.rol, Validators.required),
      matricula: new FormControl(p?.matricula, Validators.required),
      dni: new FormControl(p?.dni, Validators.required),
      idCliente: new FormControl(
        p?.idCliente ?? LoginService.getCliente()?._id,
      ),
      activo: new FormControl(this.id ? !!p?.activo : true),
      telefono: new FormControl(p?.telefono, Validators.required),
      email: new FormControl(p?.email, Validators.email),
    });
  }

  private getData(): ICreatePersonalSalud | IUpdatePersonalSalud {
    const v = this.form!.value;
    const data: ICreatePersonalSalud = {
      nombre: v.nombre?.trim(),
      rol: v.rol,
      matricula: v.matricula?.trim(),
      dni: v.dni?.trim(),
      telefono: v.telefono?.trim(),
      email: v.email?.trim() || (this.id ? '' : undefined),
      activo: !!v.activo,
    };
    if (!this.id && this.mostrarCliente && v.idCliente) {
      data.idCliente = v.idCliente;
    }
    return data;
  }

  public async onSubmit(): Promise<void> {
    if (!this.form?.valid) return;
    this.guardando = true;
    try {
      let resultado: IPersonalSalud;
      if (this.id) {
        resultado = await this.service.update(this.id, this.getData());
        this.helper.notifSuccess('Personal de salud actualizado correctamente');
      } else {
        resultado = await this.service.create(this.getData());
        this.helper.notifSuccess('Personal de salud creado correctamente');
      }
      this.close(resultado);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    } finally {
      this.guardando = false;
    }
  }

  public close(personal?: IPersonalSalud): void {
    this.dialogRef.close(personal);
  }

  async ngOnInit(): Promise<void> {
    try {
      this.id = this.data?.id;
      if (this.id) {
        this.personal = await this.service.getById(this.id);
      }
      this.title = this.id
        ? 'Editar personal de salud'
        : 'Crear personal de salud';
      this.subtitle = this.personal?.nombre;
      this.createForm();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    } finally {
      this.loading = false;
    }
  }
}
